import React, { useEffect, useState, useRef } from "react";
import { Card, Button, List, Modal, Form, Input, Image } from "antd";
import { useHistory, useParams } from "react-router-dom";
import {
  isArrayNonEmpty,
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { MY_EXIM_API_RFQ } from "../../appRedux/services/requestQuotationsNetwork";
import { isVerifiedFreightEligible, showAlert } from "../../util/helper";
import { BUSINESS_TYPE, RFQStatus } from "../../util/Constant";
import { CrownOutlined, DownloadOutlined, LeftOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { useDispatch, useSelector } from "react-redux";
import { BASE_API_CONFIG } from "util/Api";
import Messages from "./../messages/index";
import RFQStatusTags from "./RFQStatus";
import { axiosInstance } from "../../util/Api";
import TextArea from "antd/lib/input/TextArea";
import { formatDate } from "util/helper";
import { getMessagesAction } from "../../appRedux/actions/requestQuotationAction";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import SubscriptionPlans from "./../subscriptionPlan/subscriptionPlan"
import VerifiedFreightTag from "../../components/VerifiedFreightTag";

const QuotationsDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const dispatch = useDispatch();
  const authUser = useSelector(({ auth }) => auth.userData);
  
  // Add ref for Messages component
  const messagesRef = useRef();
  
  console.log("AuthUsers check---01", authUser.businessTypes?.code)
  console.log("authUser", authUser?.Subscription)

  const subscriptionstatus = authUser?.Subscription
 

  const subscription = useSelector(({ user }) => user?.subscription);
  console.log("subscription", subscription)
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);


  

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const response = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${authUser.id}`
        );
        setSubscriptionData(response.data);
      } catch (error) {
        console.error('Subscription fetch error:', error);
      }
    };

    fetchSubscription();
  }, [authUser.id]);

  const quotationIdForRating = id

  const [fileName, setFileName] = useState("");

  const [quotationsData, setQuotationsData] = useState(null);
  console.log("Quatation", quotationsData)


   const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const userId = authUser?.id;
  const subscriptionStatus= userDetails?.Subscription

  const fetchUserDetails = async () => {
      if (!userId) return;
      
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/users/${userId}`
        );
        console.log("User details from API:", response.data);
        setUserDetails(response.data?.data || response.data);
        
       
        
      } catch (err) {
        setError(err.message);
        console.error('User details fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (userId) {
        fetchUserDetails();
      }
    }, [userId]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageSubmit, setMessageSubmit] = useState(false);

  const [form] = Form.useForm();

  // Function to handle focusing the chat input in Messages component
  const handleSendMessageClick = () => {
    // Focus the chat input in Messages component
    if (messagesRef.current) {
      messagesRef.current.focusChatInput();
      
      // Optional: Scroll to Messages component
      messagesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Remove modal functions since we're not using modal anymore
  // const showModal = () => {
  //   console.log("Show modal clicked"); // Debug log
  //   setIsModalOpen(true);
  // };

  // const handleOk = () => {
  //   form
  //     .validateFields()
  //     .then((values) => {
  //       form.resetFields();
  //       setIsModalOpen(false);
  //       axiosInstance
  //         .post(`${BASE_API_CONFIG.baseURL}/messages`, {
  //           text: values.text,
  //           senderId: quotationsData.receiverId,
  //           sender: quotationsData?.receiver.name,
  //           receiverId: quotationsData.senderId,
  //           receiver: quotationsData?.sender.name,
  //           enquiryId: quotationsData.enquiryId,
  //           quotationId: quotationsData.id,
  //         })
  //         .then((response) => {
  //           setMessageSubmit(true);
  //           dispatch(
  //             getMessagesAction(
  //               true,
  //               quotationsData.id,
  //               quotationsData?.receiverId
  //             )
  //           );
  //           showAlert("success", "Success!", "Message sent successfully!");
  //         })
  //         .catch((error) => {
  //           console.error("Error:", error);
  //           showAlert("error", "Error!", "Failed to send message. Please try again.");
  //         });
  //     })
  //     .catch((info) => {
  //       console.log("Validate Failed:", info);
  //     });
  // };

  // const handleCancel = () => {
  //   form.resetFields();
  //   setIsModalOpen(false);
  // };

  const hasActiveSubscription = subscriptionData?.isActive;
  console.log("hasActiveSubscription", hasActiveSubscription)

  const isSubscriptionValid = () => {
    const activeSubscription = subscription || subscriptionData;
    console.log("activeSubscription", activeSubscription)
    if (!activeSubscription) return false;
  
    const isActive = activeSubscription.isActive && 
                    (activeSubscription.subscription?.id !== undefined);
  
    const planType = activeSubscription.subscription?.planName?.toLowerCase();
    const isPaidPlan = ['basic', 'premium'].includes(planType);
  
    const currentDate = new Date();
    const endDate = new Date(activeSubscription.subscription?.endDate);
    const isValidDate = endDate >= currentDate;
  
    console.log('Subscription Validation:', {
      isActive,
      isPaidPlan,
      isValidDate,
      planType,
      endDate,
      currentDate
    });
  
    return isActive && isPaidPlan && isValidDate;
  };

  // Determine user type based on subscriptionstatus
  const isFreeUser = subscriptionStatus === 'Free';
  const isPremiumUser = subscriptionStatus === 'Premium';

  useEffect(
    () => {
      if (isArrayNonEmpty(quotationsData?.attachments)) {
        setFileName(quotationsData?.attachments);
      }
      if (messageSubmit) {
        setMessageSubmit(false);
      }
    },
    [quotationsData, messageSubmit] // Fixed dependency array
  );

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: -100, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (isValidElement(id)) {
      dispatch(fetchStart());
      MY_EXIM_API_RFQ.getQuotationDetails({ id })
        .then((response) => {
          setQuotationsData(response?.data?.data);
          dispatch(fetchSuccess());
        })
        .catch((e) => {
          showAlert(e?.message);
          dispatch(fetchSuccess());
        });
    }
  }, [id]); // Added id dependency
  
  const approveQuotation = () => {
    let params = {
      id: id,
      data: {
        ...quotationsData,
        status: RFQStatus.ORDER_PLACED,
      },
    };
    dispatch(fetchStart());
    MY_EXIM_API_RFQ.updateQuotationDetails(params)
      .then((response) => {
        if (isValidElement(response)) {
          history.goBack();
        }
        dispatch(fetchSuccess());
      })
      .catch((e) => {
        showAlert(e?.message);
        dispatch(fetchSuccess());
      });
  };

  const {
    sender,
    price,
    units,
    description,
    enquiries,
    createdAt,
    currencyCode,
    status,
    paymentTerms,
  } = quotationsData ?? {};


  const isFreightForwarder = quotationsData?.sender?.businessTypeId === 6;
  console.log("Quatations data2 ,", isFreightForwarder)

  const { shipmentMode, shipmentType, containerType } =
    quotationsData?.enquiries ?? {};

  const unitsDisplay =
    shipmentMode === "sea"
      ? shipmentType === "fcl"
        ? `Unit (${containerType || "N/A"})`
        : "Cubic Meter"
      : units;

  const { companyName, country } = sender ?? {};
  const subscriptionValid = isSubscriptionValid();


  const goToProfilePage = () => {
    if (sender?.id) {
      history.push(`/my-profile`);
    }
  };
  
  // Company Name Display Component with Free/Premium logic
  const CompanyNameDisplay = () => {
    if (isFreeUser) {
      // Free User: Blurred company name with upgrade tag
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <span 
            style={{ 
              fontWeight: 500,
              filter: 'blur(4px)',
              userSelect: 'none',
              background: 'linear-gradient(90deg, #d9d9d9 0%, #f0f0f0 50%, #d9d9d9 100%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 1.5s infinite',
              padding: '2px 8px',
              borderRadius: '4px',
              color: 'transparent',
              textShadow: '0 0 8px rgba(0,0,0,0.3)',
              display: 'inline-block',
              minWidth: '150px'
            }}
          >
            {companyName}
          </span>
          <Tag 
            color="gold" 
            style={{ 
              cursor: 'pointer',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}
            onClick={goToProfilePage}
          >
            <CrownOutlined /> UPGRADE TO VIEW PROFILE
          </Tag>
        </div>
      );
    } else if (isPremiumUser) {
      // Premium User: Full visibility with View Profile link
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
          <span style={{ fontWeight: 500, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span>{companyName}</span>
            {isVerifiedFreightEligible(sender) && (
              <VerifiedFreightTag verifiedFreight={sender?.verifiedFreight} />
            )}
          </span>
          <span
            onClick={() => navigateBusinessCard(sender?.id, quotationIdForRating)}
            className={"myexim-link"}
            style={{
              cursor: "pointer",
              fontWeight: 500,
              padding: '4px 8px',
              borderRadius: '4px',
              transition: 'all 0.2s',
            }}
          >
            View Profile
          </span>
        </div>
      );
    }
    return null;
  };

  let data = [
    {
      label: "Received Date",
      value: formatDate(createdAt),
    },
    {
      label: "Company Name",
      value: <CompanyNameDisplay />,
    },
    isValidString(country) && {
      label: "Destination Country",
      value: enquiries?.destinationCountry,
    },
    isValidString(country) && {
      label: "Destination Port",
      value: enquiries?.destinationPort,
    },
    isValidString(paymentTerms) && {
      label: "Delivery Terms",
      value: paymentTerms,
    },
    isValidString(currencyCode) &&
      isValidString(price) &&
      (shipmentMode && shipmentType
        ? isValidString(containerType)
        : isValidString(units)) && {
        label: "Price / Unit",
        value: `${currencyCode} ${price} / ${unitsDisplay}`,
      },
    isValidString(enquiries?.qty) && {
      label: "Total Quantity",
      value: `${enquiries?.qty} ${units}`,
    },
    {
      label: "Response Message",
      value: description,
    },
    {
      label: "Status",
      value: <RFQStatusTags status={status} />,
    },
  ].filter(item => item); // Filter out false values
  
  const navigateBusinessCard = (id, quotationIdForRating) => {
    if (id && isPremiumUser) {
      history.push({
        pathname: '/user-profile',
        search: `?id=${id}`,
        state: { quotationIdForRating },
      });
    }
  };

  // Add shimmer animation to global styles
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  if (!quotationsData) {
    return <div>Loading...</div>; // Add loading state
  }

  if (isValidElement(companyName)) {
    return (
      <>
        <Card className="myexim-detail-card">
          <div className="myexim-table-title">
            <LeftOutlined
              className={"back-icon"}
              size="large"
              onClick={() => {
                history.goBack();
              }}
            />
            Quotation 
          </div>
          <div className="gx-pl-4">
            <List
              className="gx-mt-4"
              itemLayout="horizontal"
              dataSource={data}
              renderItem={(item) =>
                item?.value && (
                  <List.Item className="myexim-details-list">
                    <List.Item.Meta
                      title={<div>{item.label}</div>}
                      description={item.value}
                    />
                  </List.Item>
                )
              }
            />
          </div>

          {/* Premium Upgrade Banner - Show for Free Users */}
          {isFreeUser && (
            <div style={{
              margin: '20px 24px',
              padding: '16px 20px',
              background: 'linear-gradient(135deg, #fff7e6 0%, #fff1d6 100%)',
              border: '1px solid #ffd591',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '16px',
              boxShadow: '0 4px 12px rgba(250,173,20,0.15)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  background: '#faad14',
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <CrownOutlined style={{ color: '#fff', fontSize: '24px' }} />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '16px', color: '#613400', marginBottom: '4px' }}>
                    Upgrade To View Company Details
                  </div>
                  <div style={{ fontSize: '14px', color: '#8c5100' }}>
                    You're on a Free plan. Upgrade to Premium to view company names and profiles
                  </div>
                </div>
              </div>
            </div>
          )}

          {fileName?.length > 0 && (
            <div className="attachments gx-pl-2">
              <div className="sub-header">Attachments</div>
              <div className="gx-pt-4" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                {fileName?.map((file, index) => (
                  <div key={index} className="gx-pb-3" style={{ position: 'relative' }}>
                    <Image
                      width={150}
                      height={150}
                      src={file?.src}
                      alt={file?.originalName}
                      style={{ objectFit: 'cover', borderRadius: '8px' }}
                    />
                    <div className="gx-pt-2">
                      <a
                        href={file?.downloadUrl || file?.src}
                        download={file?.originalName}
                        className="download-link"
                        style={{
                          color: "#1677ff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "8px"
                        }}
                      >
                        <DownloadOutlined style={{ fontSize: "18px" }} /> Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="gx-mt-3" style={{ display: "flex", justifyContent: isMobile ? "center" : "flex-end", gap: "16px", flex: 1, flexWrap: 'wrap' }}>
            <Button size="large" type="primary" onClick={handleSendMessageClick}>
              Send Message
            </Button>
          </div>
        </Card>

        <Messages
          ref={messagesRef}
          id={quotationsData?.id}
          loggedInUserId={authUser?.id}
          isQuotation={true}
          quotationDetails={quotationsData}
          receiverId={quotationsData?.senderId}
          receiverName={quotationsData?.sender?.name}
        />

        {/* Comment out or remove the Modal since we're not using it anymore */}
        {/* <Modal
          title="Send Message"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleOk}>
              Send Message
            </Button>,
          ]}
        >
          <Form
            form={form}
            layout="vertical"
            name="messageForm"
          >
            <Form.Item
              name="text"
              label="Message"
              rules={[{ required: true, message: 'Please enter your message' }]}
            >
              <TextArea 
                rows={4} 
                placeholder="Type your message here..."
              />
            </Form.Item>
          </Form>
        </Modal> */}

        {/* Subscription Plans Modal */}
        <Modal
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <CrownOutlined style={{ color: '#faad14', fontSize: '24px' }} />
              <span style={{ fontSize: '18px', fontWeight: 600 }}>Upgrade to Premium</span>
            </div>
          }
          open={showSubscriptionPlans} 
          onCancel={() => setShowSubscriptionPlans(false)}
          footer={null}
          width={800}
          centered
        >
          <SubscriptionPlans 
            userDatas={authUser}
            setUserDatas={(updatedUser) => {
              setSubscriptionData(updatedUser.subscription);
              setShowSubscriptionPlans(false);
            }}
          />
        </Modal>
      </>
    );
  } else return null;
};

export default QuotationsDetails;
